import React from 'react';
import './skills.css'

import CarouselCoding from '../carouselCoding/CarouselCoding';
import SkillIcons from '../skillIcon/SkillIcon';




const Skills = () => {
    return (
        <section id="skills" className='skills'>
        <div className='skillsContainerLeft'>
        <h2>Programming Languages in My Toolkit</h2>
             <CarouselCoding />
        </div>
        <div className='skillsContainerRight'>
            <div>
                <h2  className="skillsContainerRightTitle">TECHNICAL SKILLS</h2>
                <div className='skillsWrapper'>
                    <div className="i-title">
                            <div className="i-title-wrapper">
                                <div className="i-title-item">ML</div>
                                <div className="i-title-item">Mechanics</div>
                                <div className="i-title-item">Database</div>
                                <div className="i-title-item">Egineering</div>
                                <div className="i-title-item">3D Data</div>
                                <div className="i-title-item">PyTorch</div>
                                <div className="i-title-item">CI/CD</div>
                                <div className="i-title-item">CAD/CAM</div>
                                <div className="i-title-item">Robotics</div>
                                <div className="i-title-item">Docker</div>
                                <div className="i-title-item">DL</div>
                                <div className="i-title-item">TensorFlow</div>
                                <div className="i-title-item">Neural Networks</div>
                            </div>
                        </div>
                </div>
            </div>
            <SkillIcons />
        </div>
        </section>
    );
}

export default Skills;
